// ============================================================
// ErrorBanner — 載入失敗時的統一提示（含重試）
// ------------------------------------------------------------
// 【為什麼需要】
// 體檢發現 15 個頁面用 `catch { /* silent */ }` 把錯誤吞掉，
// 畫面因此顯示「空狀態」。最危險的兩個是：
//   - 我的班表：載入失敗 → 七天全部顯示「休息」，員工以為自己沒班
//   - 補打卡：載入失敗 → 顯示「✓ 沒有漏打卡紀錄」，把待補的卡藏起來
// 兩者都是「錯誤卻理直氣壯」的假訊息，比空白畫面更糟。
// 凡是失敗會影響判斷的頁面，一律改用這個元件明講。
// ============================================================

interface Props {
  message: string;
  onRetry?: () => void;
}

export function ErrorBanner({ message, onRetry }: Props) {
  return (
    <div className="rounded-xl border border-rose-200 bg-rose-50 px-4 py-3 space-y-2">
      <div className="text-sm text-rose-600">
        <span className="font-semibold">載入失敗</span>
        <span className="block mt-0.5 text-rose-500">{message}</span>
      </div>
      <p className="text-xs text-rose-400">
        畫面上的資料可能不完整，請重試後再判斷。
      </p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="w-full py-2 rounded-btn bg-rose-500 text-white text-sm font-medium hover:bg-rose-600 active:scale-[0.98] transition-all"
        >
          重新載入
        </button>
      )}
    </div>
  );
}
